<template>
  <div class="page-content pb-6">
    <v-card
      color="grey lighten-5"
      style="max-width: 85%"
      elevation="4"
      class="mx-auto"
    >
      <!-- Icon change perfil -->
      <v-row align="center" justify="end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="editing"
              icon
              x-large
              class="mr-4 mt-1"
              @click="editing = true"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Clique aqui para editar as suas informações</span>
        </v-tooltip>
      </v-row>
      <!--/ Icon change perfil -->
      <v-form @submit.prevent="changeInformationsPerfil" class="mx-4">
        <v-row>
          <v-col cols="7">
            <v-row>
              <v-col cols="5" class="pl-8">
                <h5 class="pl-8 pt-1 details">
                  {{ $t("texts.perfilName") }}
                </h5></v-col
              >
              <v-col cols="7">
                <a-text-field
                  v-model="$v.formInputName.$model"
                  :validator="$v.formInputName"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="pl-8">
                <h5 class="pl-8 pt-1 details">
                  {{ $t("texts.perfilEmail") }}
                </h5></v-col
              >
              <v-col cols="7">
                <a-text-field
                  v-model="$v.formInputEmail.$model"
                  :validator="$v.formInputEmail"
                  :readonly="!editing"
                  type="email"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters['Auth/getUser']['type'] === 1">
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.perfilBirthday") }}
                </h5></v-col
              >
              <v-col cols="7">
                <a-date-field-menu
                  v-model="formInputBirthdate"
                  birthdate
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-date-field-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.perfilPhone") }} :
                </h5></v-col
              >
              <v-col cols="7">
                <a-text-field
                  v-model="$v.formInputMobileNumber.$model"
                  :validator="$v.formInputMobileNumber"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row
              v-if="[2, 3].includes($store.getters['Auth/getUser']['type'])"
            >
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.namePerson") }} :
                </h5></v-col
              >
              <v-col cols="7">
                <a-text-field
                  v-model="formInputNamePerson"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters['Auth/getUser']['type'] === 1">
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.perfilSchoolServices") }}
                </h5></v-col
              >
              <v-col cols="7">
                <a-text-field
                  v-model="$v.formInputSchool.$model"
                  :validator="$v.formInputSchool"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters['Auth/getUser']['type'] === 1">
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.perfilCourseFormation") }}
                </h5>
              </v-col>
              <v-col cols="7">
                <a-text-field
                  v-model="$v.formInputCourse.$model"
                  :validator="$v.formInputCourse"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters['Auth/getUser']['type'] !== 4">
              <v-col cols="5" class="pl-8">
                <h5 class="pt-1 pl-8 details">
                  {{ $t("texts.observations") }}
                </h5>
              </v-col>
              <v-col cols="7">
                <a-textarea
                  v-model="formInputComments"
                  :readonly="!editing"
                  class="pt-0 mt-0"
                ></a-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" v-if="$store.getters['Auth/getUser']['type'] === 1">
            <v-row class="pl-8 pt-1">
              <v-col cols="12">
                <h5 class="pl-1 details">
                  {{ $t("texts.volunteermotivationsprofile") }}
                </h5>
              </v-col>
            </v-row>
            <v-row class="pl-8">
              <v-col cols="12">
                <ul v-if="!editing">
                  <li
                    v-for="motivation in formInputMotivations"
                    :key="motivation"
                    class="pb-3"
                  >
                    {{ getMotivationsText(motivation) }}
                  </li>
                </ul>
                <a-select
                  v-else
                  v-model="formInputMotivations"
                  :items="volunteerMotivations"
                  multiple
                ></a-select>
              </v-col>
            </v-row>
            <v-row class="pl-8 pt-1">
              <v-col cols="12">
                <h5 class="pl-1 details">
                  {{ $t("texts.perfilAreasOfInterest") }}
                </h5>
              </v-col>
            </v-row>
            <v-row class="pl-8">
              <v-col cols="12">
                <ul v-if="!editing">
                  <li
                    v-for="areaOfInterest in formInputAreasOfInterest"
                    :key="areaOfInterest"
                    class="pb-3"
                  >
                    {{ getAreaOfInterestText(areaOfInterest) }}
                  </li>
                </ul>
                <a-select
                  v-else
                  v-model="formInputAreasOfInterest"
                  :items="volunteerAreasOfInterest"
                  multiple
                ></a-select>
              </v-col>
            </v-row>
            <v-row class="pl-8">
              <v-col cols="5">
                <h5 class="pt-10 details">{{ $t("texts.hoursDone") }}:</h5>
              </v-col>
              <v-col cols="7">
                <h5 class="pt-10 details">
                  {{
                    $t("texts.hoursMinutesDone", {
                      hoursDone: formHoursDone,
                      minutesDone: formMinutesDone
                    })
                  }}
                </h5>
              </v-col>
            </v-row>
            <!-- <v-row class="pt-4 pl-8">
              <v-col cols="1">
                <v-icon large class="mr-3">mdi-star</v-icon>
              </v-col>
              <v-col cols="8" class="pt-3 pl-3">
                <h5>[Valor]</h5>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
        <v-row justify="end" class="pr-9 pt-2 pb-6">
          <v-col v-if="!editing" cols="2">
            <v-btn
              class="primary"
              @click.stop="$store.dispatch('Util/showChangePasswordDialog')"
              >{{ $t("texts.changepassowrd") }}</v-btn
            >
          </v-col>
          <v-col v-if="editing" cols="2">
            <v-btn class="primary--text" @click="editing = false">{{
              $t("texts.cancel")
            }}</v-btn>
          </v-col>
          <v-col v-if="editing" cols="2">
            <v-btn color="primary" block type="submit">{{
              $t("texts.change")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<style scoped lang="sass">
.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1
  padding: 5px

h5.details
  font-weight: bold
</style>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";
import ATextField from "@/components/fields/ATextField.vue";
import ASelect from "@/components/fields/ASelect.vue";
import ADateFieldMenu from "@/components/fields/ADateFieldMenu.vue";
import ATextarea from "@/components/fields/ATextarea.vue";

import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import { tel } from "@/validators";

export default {
  name: "profile-detail",

  components: {
    ATextField,
    ASelect,
    ADateFieldMenu,
    ATextarea
  },

  mounted: function() {
    this.loadData();
  },

  mixins: [validationMixin],

  validations: {
    // Form validations
    formInputName: { required },
    formInputEmail: { required, email },
    formInputMobileNumber: { tel },
    formInputSchool: { minLength: minLength(4) },
    formInputCourse: { minLength: minLength(4) }
  },

  data() {
    return {
      // Form data
      formInputName: null,
      formInputEmail: null,
      formInputBirthdate: null,
      formInputMobileNumber: null,
      formInputSchool: null,
      formInputCourse: null,
      formInputAreasOfInterest: null,
      formHoursDone: null,
      formMinutesDone: null,
      formEntity: null,
      formInputComments: null,
      formInputMotivations: null,
      formInputNamePerson: null,

      // Editing state
      editing: false
    };
  },

  methods: {
    /**
     * Get user details
     * @public
     */
    loadData() {
      // Load form data
      const loadFormData = this.$api({
        url: this.$config.api.route.userProfile,
        method: "GET"
      }).then(resp => {
        const {
          name,
          email,
          comments,
          volunteer,
          mobileNumber,
          entity
        } = resp.data;
        this.formInputName = name;
        this.formInputEmail = email;
        this.formInputMobileNumber = mobileNumber;
        this.formInputComments = comments;
        if (volunteer) {
          this.formInputBirthdate = volunteer.birthday;
          this.formInputSchool = volunteer.schoolId;
          this.formInputCourse = volunteer.course;
          this.formInputAreasOfInterest = volunteer.interestAreadIds;
          this.formInputMotivations = volunteer.motivations?.ids;

          let convertedTime = this.timeConvert(volunteer.totalHoursDone);
          this.formHoursDone = convertedTime.hours;
          this.formMinutesDone = convertedTime.minutes;
        }
        if (entity) {
          this.formEntity = entity;
          this.formInputNamePerson = entity?.namePerson;
        }
      });

      // Async handle loads
      this.$store.dispatch("Util/startLoading");
      Promise.all([loadFormData])
        .catch(() => {
          AppError.handle(new AppError("LOAD_DATA_UNKNOWN"));
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },

    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return {
        hours: rhours,
        minutes: rminutes
      };
    },

    /**
     * Change profile informations
     * @public
     */
    changeInformationsPerfil() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch("Util/startLoading");
      if (this.formEntity)
        this.formEntity.namePerson = this.formInputNamePerson;
      this.$api({
        url: this.$config.api.route.userProfile,
        data: {
          name: this.formInputName,
          email: this.formInputEmail,
          mobileNumber: this.formInputMobileNumber,
          comments: this.formInputComments,
          volunteer: {
            birthday: this.formInputBirthdate,
            schoolId: this.formInputSchool,
            course: this.formInputCourse,
            interestAreadIds: this.formInputAreasOfInterest,
            motivations: { ids: this.formInputMotivations }
          },
          entity: this.formEntity
        },
        method: "PUT"
      })
        .then(() => {
          this.editing = false;
          this.loadData();

          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.profileupdated")
          );

          // Reset fields and validations
          this.formInputName = null;
          this.formInputEmail = null;
          this.formInputBirthdate = null;
          this.formInputMobileNumber = null;
          this.formInputSchool = null;
          this.formInputCourse = null;
          this.formInputAreasOfInterest = null;
          this.formInputComments = null;
          this.formInputMotivations = null;
          this.formInputNamePerson = null;
          this.formEntity = null;
          this.$v.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },

    /**
     * Get the interest areas
     * @param {string} value - the interest area.
     * @public
     */
    getAreaOfInterestText(value) {
      const areaOfInterest = this.volunteerAreasOfInterest.find(
        element => element.value === value
      );
      return areaOfInterest ? areaOfInterest.text : value;
    },

    /**
     * Get the motivations
     * @param {string} value - the motivation
     * @public
     */
    getMotivationsText(value) {
      const motivation = this.volunteerMotivations.find(
        element => element.value === value
      );
      return motivation ? motivation.text : value;
    }
  },

  computed: {
    // Volunteer areas of interest
    volunteerAreasOfInterest() {
      return [
        {
          value: 1,
          text: this.$t("texts.volunteerareasofinterest.1")
        },
        {
          value: 2,
          text: this.$t("texts.volunteerareasofinterest.2")
        },
        {
          value: 3,
          text: this.$t("texts.volunteerareasofinterest.3")
        },
        {
          value: 4,
          text: this.$t("texts.volunteerareasofinterest.4")
        },
        {
          value: 5,
          text: this.$t("texts.volunteerareasofinterest.5")
        },
        {
          value: 6,
          text: this.$t("texts.volunteerareasofinterest.6")
        },
        {
          value: 7,
          text: this.$t("texts.volunteerareasofinterest.7")
        },
        {
          value: 8,
          text: this.$t("texts.volunteerareasofinterest.8")
        }
      ];
    },
    // Volunteer motivations
    volunteerMotivations() {
      return [
        {
          value: 2,
          text: this.$t("texts.volunteermotivations.2")
        },
        {
          value: 3,
          text: this.$t("texts.volunteermotivations.3")
        },
        {
          value: 5,
          text: this.$t("texts.volunteermotivations.5")
        },
        {
          value: 6,
          text: this.$t("texts.volunteermotivations.6")
        },
        {
          value: 7,
          text: this.$t("texts.volunteermotivations.7")
        },
        {
          value: 8,
          text: this.$t("texts.volunteermotivations.8")
        },
        {
          value: 9,
          text: this.$t("texts.volunteermotivations.9")
        },
        {
          value: 10,
          text: this.$t("texts.volunteermotivations.10")
        },
        {
          value: 1,
          text: this.$t("texts.other")
        }
      ];
    }
  }
};
</script>
